import { Link } from "react-router-dom";
import companyInfo from "../images/logoname.jpeg";
import { Badge } from "../Components/ui/Badge";
import { Button } from "../Components/ui/Button";

const founderMessage = {
  name: "Muhammad Shahzaib",
  role: "Founder & CEO",
  image: "/team-headshots/shahzaib.png",
  quote:
    "I started Quantum Spark Technology because founders deserve a team that ships — not endless retainers with no exit criteria. We stay hands-on in architecture and quality, keep scope honest, and treat every launch like our reputation depends on it.",
};

export default function AboutSection() {
  return (
    <section id="about-us" className="border-t border-zinc-200 bg-white py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid items-center gap-16 lg:grid-cols-2">
          <div className="overflow-hidden rounded-3xl border border-zinc-200 bg-zinc-50">
            <img src={companyInfo} alt="Quantum Spark Technology team" className="h-full w-full object-cover" />
          </div>

          <div>
            <Badge className="mb-6 rounded-full border border-zinc-200 bg-brand-surface px-4 py-1 text-brand-ink">
              About Us
            </Badge>
            <h2 className="mb-6 font-display text-4xl font-bold text-brand-ink md:text-5xl">
              A senior-led studio for products that need to <span className="text-brand-purple">ship.</span>
            </h2>
            <p className="mb-4 text-lg leading-relaxed text-brand-muted">
              Quantum Spark Technology designs and builds web apps, mobile products, AI-assisted features, and blockchain
              platforms for startups and growing companies. We keep scope honest, architecture practical, and delivery
              visible every week.
            </p>
            <p className="mb-8 text-lg leading-relaxed text-brand-muted">
              Recent work includes SkinSeoul commerce, ISCE NFC product surfaces, and the full MustangIP marketplace — real
              products with real users, not portfolio filler.
            </p>

            <div className="mb-8 rounded-3xl border border-zinc-200 bg-[#FAFAFB] p-6">
              <p className="mb-5 text-base italic leading-relaxed text-brand-muted">&ldquo;{founderMessage.quote}&rdquo;</p>
              <div className="flex items-center gap-4">
                <img
                  src={founderMessage.image}
                  alt={founderMessage.name}
                  className="h-14 w-14 rounded-full border border-zinc-200 object-cover"
                />
                <div>
                  <p className="font-display font-bold text-brand-ink">{founderMessage.name}</p>
                  <p className="text-sm font-medium text-brand-purple">{founderMessage.role}</p>
                </div>
              </div>
            </div>

            <Link to="/about">
              <Button className="rounded-full bg-brand-purple px-6 text-white hover:bg-brand-purple-dark">
                Read our full story
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
